import request from '@/utils/request'

export const cancelCredit = (id: string, comment: string) =>
  request({
    url: `/admin/budget_moves/${id}/cancel_credit`,
    method: 'put',
    data: { comment }
  })

export const validatePending = (id: string, receivedAmount: string, reference: string, sendAt: string, comment: string) =>
  request({
    url: `/admin/budget_moves/${id}/validate_pending`,
    method: 'put',
    data: { received_amount: receivedAmount, reference, send_at: sendAt, comment }
  })
